/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Review_Annotations_DescriptionInputs */

const en_review_annotations_description = /** @type {(inputs: Review_Annotations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View detailed feedback with annotations directly on your resume`)
};

const de_review_annotations_description = /** @type {(inputs: Review_Annotations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detailliertes Feedback mit Anmerkungen direkt in deinem Lebenslauf anzeigen`)
};

/**
* | output |
* | --- |
* | "View detailed feedback with annotations directly on your resume" |
*
* @param {Review_Annotations_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const review_annotations_description = /** @type {((inputs?: Review_Annotations_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Review_Annotations_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_review_annotations_description(inputs)
	return en_review_annotations_description(inputs)
});